import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_PAGINATOR_DEFAULT_OPTIONS, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ToastrModule } from 'ngx-toastr';
import { provideUiTour } from 'ngx-ui-tour-md-menu';
import { APP_ROUTES } from './app.routes';
import { ResponsiveBreakpointsService } from './core/responsive-breakpoints/responsive-breakpoints.service';
import { SideMenuService } from './core/side-menu/side-menu.service';
import { provideAddBillingitemTopackageWizardStoreV26 } from './root-store-v26/allocation-wizard-store/add-billingitem-topackage-store/add-billingitem-topackage-wizard.providers';
import { provideAddServiceTopackageWizardStoreV26 } from './root-store-v26/allocation-wizard-store/add-service-topackage-store';
import { provideAddServicesToContractsWizardStoreV26 } from './root-store-v26/allocation-wizard-store/add-services-to-contracts-store';
import { provideAllocateConsumerFromBillingitemWizardStoreV26 } from './root-store-v26/allocation-wizard-store/allocate-consumer-from-billingitem-wizard-store';
import { provideAllocateServiceWizardStoreV26 } from './root-store-v26/allocation-wizard-store/allocate-service-wizard-store/allocate-service-wizard.providers';
import { provideAllocationCancelWizardStoreV26 } from './root-store-v26/allocation-wizard-store/cancel-wizard-store';
import { provideFoUserLicenseServicesStoreV26 } from './root-store-v26/allocation-wizard-store/cancel-wizard-store/fo-user-product-services-store';
import { provideCopyAssetWizardStoreV26 } from './root-store-v26/allocation-wizard-store/copy-asset-wizard-store';
import { provideCopyBillingitemsWizardStoreV26 } from './root-store-v26/allocation-wizard-store/copy-billingitems-wizard-store/copy-billingitems-wizard.providers';
import { provideMoveBillingitemsWizardStoreV26 } from './root-store-v26/allocation-wizard-store/move-billingitems-wizard-store/move-billingitems-wizard.providers';
import { provideAllocationMoveWizardStoreV26 } from './root-store-v26/allocation-wizard-store/move-wizard-store/move-wizard.providers';
import { provideReactivateAssetWizardStoreV26 } from './root-store-v26/allocation-wizard-store/reactivate-asset-wizard-store';
import { provideReallocateCancelAssetWizardStoreV26 } from './root-store-v26/allocation-wizard-store/reallocate-cancel-asset-wizard-store/reallocate-cancel-asset-wizard.providers';
import { provideReplaceBillingitemsWizardStoreV26 } from './root-store-v26/allocation-wizard-store/replace-billingitems-wizard-store/replace-billingitems-wizard.providers';
import { provideReplaceProductServiceWizardStoreV26 } from './root-store-v26/allocation-wizard-store/replace-product-service-wizard-store';
import { provideAllocationSwapContractWizardStoreV26 } from './root-store-v26/allocation-wizard-store/swap-contract-wizard-store';
import { provideTerminateMultiAddonsWizardStoreV26 } from './root-store-v26/allocation-wizard-store/terminate-multi-addonds-wizard-store/terminate-multi-addons-wizard.providers';
import { provideTerminateMultiAssetWizardStoreV26 } from './root-store-v26/allocation-wizard-store/terminate-multi-asset-wizard-store';
import { provideAddBillingitemTopackageWizardStore } from './root-store/allocation-wizard-store/add-billingitem-topackage-store';
import { provideAddServiceTopackageWizardStore } from './root-store/allocation-wizard-store/add-service-topackage-store';
import { provideAddServicesToBillingaccountsWizardStore } from './root-store/allocation-wizard-store/add-services-to-billingaccounts-store';
import { provideAddSubscriptionsWizardStore } from './root-store/allocation-wizard-store/add-subscriptions-store';
import { provideAllocateConsumerFromBillingitemWizardStore } from './root-store/allocation-wizard-store/allocate-consumer-from-billingitem-wizard-store';
import { provideAllocateServiceWizardStore } from './root-store/allocation-wizard-store/allocate-service-wizard-store';
import { provideAllocationCancelWizardStore } from './root-store/allocation-wizard-store/cancel-wizard-store';
import { provideFoUserLicenseServicesStore } from './root-store/allocation-wizard-store/cancel-wizard-store/fo-user-product-services-store';
import { provideChangeCostcentreAllocationsWizardStore } from './root-store/allocation-wizard-store/change-costcentre-allocations-wizard-store';
import { provideCopyAssetWizardStore } from './root-store/allocation-wizard-store/copy-asset-wizard-store';
import { provideCopyBillingitemsWizardStore } from './root-store/allocation-wizard-store/copy-billingitems-wizard-store';
import { provideDeactivateBillingitemAssetWizardStore } from './root-store/allocation-wizard-store/deactivate-billingitem-asset-wizard-store';
import { provideModifyTypeWizardStore } from './root-store/allocation-wizard-store/modify-type-store';
import { provideMoveAllDesksWizardStore } from './root-store/allocation-wizard-store/move-all-desks-wizard-store';
import { provideMoveAssetBillingaccountsWizardStore } from './root-store/allocation-wizard-store/move-asset-billingaccounts-wizard-store';
import { provideMoveBillingitemsWizardStore } from './root-store/allocation-wizard-store/move-billingitems-wizard-store';
import { provideAllocationMoveWizardStore } from './root-store/allocation-wizard-store/move-wizard-store';
import { provideOrderMarketDataWizardStore } from './root-store/allocation-wizard-store/order-market-data-wizard-store';
import { provideProductConfigurationStore } from './root-store/allocation-wizard-store/product-type-config-store';
import { provideReactivateAssetWizardStore } from './root-store/allocation-wizard-store/reactivate-asset-wizard-store';
import { provideReallocateCancelAssetWizardStore } from './root-store/allocation-wizard-store/reallocate-cancel-asset-wizard-store';
import { provideReplaceBillingitemsWizardStore } from './root-store/allocation-wizard-store/replace-billingitems-wizard-store';
import { provideReplaceFeeditemsWizardStore } from './root-store/allocation-wizard-store/replace-feeditems-wizard-store';
import { provideReplaceProductServiceWizardStore } from './root-store/allocation-wizard-store/replace-product-service-wizard-store';
import { provideAllocationSwapContractWizardStore } from './root-store/allocation-wizard-store/swap-contract-wizard-store';
import { provideTerminateMultiAddonsWizardStore } from './root-store/allocation-wizard-store/terminate-multi-addonds-wizard-store';
import { provideTerminateMultiAssetWizardStore } from './root-store/allocation-wizard-store/terminate-multi-asset-wizard-store';
import { provideAuthStore } from './root-store/auth-store';
import { provideConfigurationSearchStore } from './root-store/configuration-tiles-search-store';
import { provideCoreUiInterfaceStore } from './root-store/core-ui-interface.store';
import { provideErrorHandlingStore } from './root-store/error-handling-store';
import { provideFinesseChatbotInterfaceStore } from './root-store/finesse-chatbot-interface.store';
import { provideGlobalDateFilterStore } from './root-store/global-date-filter-store';
import { provideGlobalSearchStore } from './root-store/global-search-store';
import { provideImageFullscreenViewerStore } from './root-store/image-fullscreen-viewer-store';
import { provideModuleItemStore } from './root-store/module-item-store';
import { provideNotificationsStore } from './root-store/notifications-store';
import { providePreferencesStore } from './root-store/preferences-store';
import { provideRequestsStore } from './root-store/requests-store';
import { provideRestrictedAuthStore } from './root-store/restricted-auth-store';
import { provideRootStore } from './root-store/root-store.providers';
import { TokenService } from './services/auth/token.service';
import { AppLanguageInterceptor } from './services/http-interceptors.ts/app-language.interceptors';
import { CleanEmptyFieldReuqestInterceptor } from './services/http-interceptors.ts/clean-empty-field-request.interceptor';
import { ClientCallOriginInterceptor } from './services/http-interceptors.ts/client-call-origin.interceptor';
import { DateHeaderInterceptor } from './services/http-interceptors.ts/date-header.interceptors';
import { EncodeHttpParamsInterceptor } from './services/http-interceptors.ts/encode-http-params.interceptors';
import { GlobalFilterInterceptor } from './services/http-interceptors.ts/global-filter.interceptors';
import { AuthJWTInterceptor } from './services/http-interceptors.ts/jwt-interceptor';
import { RestrictedAuthJWTInterceptor } from './services/http-interceptors.ts/restricted-jwt-interceptor';
import { BlobErrorHttpInterceptor } from './services/http-interceptors.ts/server-error/server-blob-error-interceptor';
import { ServerErrorInterceptor } from './services/http-interceptors.ts/server-error/server-error-interceptor';
import { MatPaginatorTranslations } from './shared/paginator-intl/paginator-intl';
import { CustomTranslateLoader } from './shared/translate-text/translate-loader';

const DATEPICKER_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const APP_CONFIG_MODULES = [
  ToastrModule.forRoot({
    timeOut: 5000,
    positionClass: 'toast-bottom-left',
    preventDuplicates: true,
    countDuplicates: true,
    includeTitleDuplicates: true,
    newestOnTop: true,
    maxOpened: 2,
    autoDismiss: true,
  }),
  NgCircleProgressModule.forRoot({}),
  BrowserAnimationsModule,
  MatMomentDateModule,
  MatSidenavModule,
];

const APP_ROUTER_PROVIDERS = [provideRouter(APP_ROUTES)];

const APP_HTTP_INTERCEPTOR_PROVIDERS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ClientCallOriginInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AppLanguageInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: RestrictedAuthJWTInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthJWTInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: GlobalFilterInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ServerErrorInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: BlobErrorHttpInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: EncodeHttpParamsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DateHeaderInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CleanEmptyFieldReuqestInterceptor,
    multi: true,
  },
];

const APP_UI_TOKEN_PROVIDERS = [
  { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: { formFieldAppearance: 'outline' } },
  { provide: MatPaginatorIntl, useClass: MatPaginatorTranslations },
  DatePipe,
  { provide: MAT_DATE_LOCALE, useValue: 'en-gb' },
  { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  { provide: MAT_DATE_FORMATS, useValue: DATEPICKER_FORMATS },
  {
    provide: OVERLAY_DEFAULT_CONFIG,
    useValue: { usePopover: false },
  },
];

const APP_ROOT_STORE_PROVIDERS = [
  provideRootStore(),
  provideAuthStore(),
  provideRestrictedAuthStore(),
  provideModuleItemStore(),
  provideErrorHandlingStore(),
  provideImageFullscreenViewerStore(),
  provideCoreUiInterfaceStore(),
  provideFinesseChatbotInterfaceStore(),
  provideRequestsStore(),
  providePreferencesStore(),
  provideGlobalSearchStore(),
  provideGlobalDateFilterStore(),
  provideNotificationsStore(),
  provideConfigurationSearchStore(),
];

const APP_WIZARD_STORE_PROVIDERS = [
  provideProductConfigurationStore(),
  provideFoUserLicenseServicesStore(),
  provideAllocationCancelWizardStore(),
  provideCopyAssetWizardStore(),
  provideCopyBillingitemsWizardStore(),
  provideReactivateAssetWizardStore(),
  provideAllocationMoveWizardStore(),
  provideMoveBillingitemsWizardStore(),
  provideMoveAssetBillingaccountsWizardStore(),
  provideMoveAllDesksWizardStore(),
  provideAllocationSwapContractWizardStore(),
  provideReallocateCancelAssetWizardStore(),
  provideAddBillingitemTopackageWizardStore(),
  provideAddServiceTopackageWizardStore(),
  provideAddServicesToBillingaccountsWizardStore(),
  provideAddSubscriptionsWizardStore(),
  provideAllocateServiceWizardStore(),
  provideAllocateConsumerFromBillingitemWizardStore(),
  provideReplaceBillingitemsWizardStore(),
  provideReplaceFeeditemsWizardStore(),
  provideReplaceProductServiceWizardStore(),
  provideChangeCostcentreAllocationsWizardStore(),
  provideDeactivateBillingitemAssetWizardStore(),
  provideOrderMarketDataWizardStore(),
  provideTerminateMultiAddonsWizardStore(),
  provideTerminateMultiAssetWizardStore(),
  provideModifyTypeWizardStore(),
];

const APP_WIZARD_STORE_PROVIDERS_V26 = [
  provideAllocateServiceWizardStoreV26(),
  provideCopyAssetWizardStoreV26(),
  provideReactivateAssetWizardStoreV26(),
  provideReplaceProductServiceWizardStoreV26(),
  provideReallocateCancelAssetWizardStoreV26(),
  provideMoveBillingitemsWizardStoreV26(),
  provideCopyBillingitemsWizardStoreV26(),
  provideReplaceBillingitemsWizardStoreV26(),
  provideTerminateMultiAddonsWizardStoreV26(),
  provideAddServiceTopackageWizardStoreV26(),
  provideAddBillingitemTopackageWizardStoreV26(),
  provideAllocationMoveWizardStoreV26(),
  provideFoUserLicenseServicesStoreV26(),
  provideAllocationCancelWizardStoreV26(),
  provideAllocateConsumerFromBillingitemWizardStoreV26(),
  provideTerminateMultiAssetWizardStoreV26(),
  provideAllocationSwapContractWizardStoreV26(),
  provideAddServicesToContractsWizardStoreV26(),
];

const APP_CORE_SERVICE_PROVIDERS = [ResponsiveBreakpointsService, SideMenuService];

const APP_HTTP_CLIENT_PROVIDERS = [provideHttpClient(withXhr(), withInterceptorsFromDi())];

const APP_TRANSLATE_PROVIDERS = [
  provideTranslateService({
    loader: provideTranslateLoader(() => new CustomTranslateLoader(inject(HttpClient), inject(TokenService))),
  }),
];

export const APP_CONFIG_PROVIDERS = [
  ...APP_ROUTER_PROVIDERS,
  ...APP_TRANSLATE_PROVIDERS,
  ...APP_HTTP_INTERCEPTOR_PROVIDERS,
  ...APP_UI_TOKEN_PROVIDERS,
  ...APP_ROOT_STORE_PROVIDERS,
  ...APP_WIZARD_STORE_PROVIDERS,
  ...APP_WIZARD_STORE_PROVIDERS_V26,
  ...APP_CORE_SERVICE_PROVIDERS,
  ...APP_HTTP_CLIENT_PROVIDERS,
  provideUiTour(),
];

export const appConfig: ApplicationConfig = {
  providers: [importProvidersFrom(...APP_CONFIG_MODULES), ...APP_CONFIG_PROVIDERS],
};
